import React from 'react';
import { labelConfig } from '../constants/labelConfig';

import { Text } from '../../../../../../../../../ui-kit';
import '../styles/_timestamp-label.scss';

const TimestampLabel = (props) => {
  const { timestamp, visibility = '', isRejected } = props;
  const config = labelConfig[visibility] || labelConfig.PUBLIC;
  return (
    <div
      className="timestamp-label"
      style={{
        backgroundColor: config.bgColor
      }}>

      <Text
        style={{
          color: config.textColor
        }}
        label>

        {!isRejected ? timestamp : 'Sign-off rejected'}
      </Text>
    </div>);

};

export default TimestampLabel;